<template>
    <div class="member-center">
        <div class="header">
            <div class="slider-banner banner">
                <swiper
                    class="swiper-wrapper"
                    :options="swiperVip"
                    ref="mySwiper"
                    @slideChange="slideChange"
                >
                    <swiperSlide
                        class="swiper-slide memberBg"
                        :class="item.class"
                        v-for="(item, index) in memberVipList"
                        :key="index"
                        :style="{ backgroundImage: 'url(' + item.bgImg + ')' }"
                    >
                        <div class="level-txt">当前等级</div>
                        <div class="name">{{ item.name }}</div>
                        <img :src="item.activeImg" class="medal" alt="" />
                        <div class="achievement">
                            <div class="ach-top ">
                                <div class="top-left">团队业绩</div>
                                <div class="top-right">
                                    <span class="text-color">{{
                                        item.user_price
                                    }}</span
                                    >/{{ item.user_max_price }}
                                </div>
                            </div>
                            <div class="cu-progress">
                                <div class="bg-red" :style="{width:(item.user_price/item.user_max_price>1 ?1:item.user_price/item.user_max_price)*100+'%'}"></div>
                            </div>
                        </div>
                        <div class="lock">
                            还需要{{item.user_max_price-item.user_price>=0 ? item.user_max_price-item.user_price:0}}元团队业绩升级至红卡会员
                        </div>
                    </swiperSlide>
                </swiper>
            </div>
        </div>
        <div style="height:130px"></div>
        <div class="speak">
            <div
                class="speak-txt"
                :style="{
                    backgroundImage:
                        'url(' + memberVipList[activeIndex].text_bg + ')',
                }"
            >
                {{ memberVipList[activeIndex].name }}等级权益说明
            </div>
            <div class="speak-people">
                <div class="speak-people-top">
                    <img src="../../assets/newImg/vip_speak_1.png" alt="" />
                    <div>个人比例收入</div>
                </div>
                <div class="content">
                    个人业绩x{{ memberVipList[activeIndex].proportion }}%
                </div>
            </div>
            <div class="speak-people">
                <div class="speak-people-top">
                    <img src="../../assets/newImg/vip_speak_2.png" alt="" />
                    <div>直属会员差额奖金</div>
                </div>
                <div class="content">
                    直质会员业绩×（个人业绩返到比例一直属会员返动比例）
                </div>
            </div>
            <div class="speak-people">
                <div class="speak-people-top">
                    <img src="../../assets/newImg/vip_speak_3.png" alt="" />
                    <div>推广奖金</div>
                </div>
                <div class="content">
                    团队业绩×推广奖金比例
                </div>
            </div>
            <div style="height:20px"></div>
        </div>
        <div style="height:20px"></div>
        <div class="wrapper" v-if="activeIndex > 0">
            <div
                class="speak-txt"
                :style="{ backgroundImage: 'url(' + memberVipList[activeIndex].text_bg + ')' }"
            >
                {{ memberVipList[activeIndex].name }}等级推广奖金说明
            </div>
            <div style="height:12px"></div>
            <div class="speakvip">
                <div class="speak-list">
                    <div class="title">基础条件需同时满足以下两点</div>
                    <div class="speak-li">
                        <div class="li-top">
                            <div class="li-top-left">
                                个人业绩：<span class="text-color">{{memberVipList[activeIndex].user_price}}</span
                                >/{{memberVipList[activeIndex].user_promotion_performance}}
                            </div>
                            <div class="li-top-right">还需要{{memberVipList[activeIndex].user_promotion_performance-memberVipList[activeIndex].user_price>=0 ? memberVipList[activeIndex].user_promotion_performance-memberVipList[activeIndex].user_price:0}}元</div>
                        </div>
                        <div class="cu-progress">
                            <div class="bg-red" :style="{width:(memberVipList[activeIndex].user_price/memberVipList[activeIndex].user_promotion_performance>=1 ?1:memberVipList[activeIndex].user_price/memberVipList[activeIndex].user_promotion_performance)*100+'%'}"></div>
                        </div>
                    </div>
                    <div class="speak-li">
                        <div class="li-top">
                            <div class="li-top-left">
                                下级业绩：<span class="text-color">{{memberVipList[activeIndex].team_price-memberVipList[activeIndex].user_price}}</span
                                >/{{memberVipList[activeIndex].team_promotion_performance}}
                            </div>
                            <div class="li-top-right">还需要{{memberVipList[activeIndex].team_promotion_performance-memberVipList[activeIndex].team_price+memberVipList[activeIndex].user_price>=0 ?memberVipList[activeIndex].team_promotion_performance-memberVipList[activeIndex].team_price+memberVipList[activeIndex].user_price:0}}元</div>
                        </div>
                        <div class="cu-progress">
                            <div class="bg-red" :style="{width:((memberVipList[activeIndex].team_price-memberVipList[activeIndex].user_price)/memberVipList[activeIndex].team_promotion_performance>=1 ?1:(memberVipList[activeIndex].team_price-memberVipList[activeIndex].user_price)/memberVipList[activeIndex].team_promotion_performance)*100+'%'}"></div>
                        </div>
                    </div>
                </div>
                <div style="height:11px"></div>
                <div class="speak-list" style="height:160px">
                    <div class="title">推广奖金计算公式</div>
                    <div class="speak-li">
                        <div class="li-top">
                            <div class="li-top-left">
                                团队业绩：<span class="text-color">{{memberVipList[activeIndex].team_price}}</span
                                >/{{memberVipList[activeIndex].max_promotion_performance_two || memberVipList[activeIndex].max_promotion_performance}}
                            </div>
                            <div class="li-top-right">还需要{{(memberVipList[activeIndex].max_promotion_performance_two || memberVipList[activeIndex].max_promotion_performance) -memberVipList[activeIndex].team_price>=0 ? (memberVipList[activeIndex].max_promotion_performance_two || memberVipList[activeIndex].max_promotion_performance)-memberVipList[activeIndex].team_price:0}}元</div>
                        </div>
                        <div class="cu-progress">
                            <div class="bg-red" :style="{width:(memberVipList[activeIndex].team_price/(memberVipList[activeIndex].max_promotion_performance_two || memberVipList[activeIndex].max_promotion_performance)>=1 ? 1:memberVipList[activeIndex].team_price/(memberVipList[activeIndex].max_promotion_performance_two || memberVipList[activeIndex].max_promotion_performance))*100+'%'}"></div>
                        </div>
                    </div>
                    <div class="speak-li">
                        <div class="li-top">
                            <div class="li-top-left">
                                {{memberVipList[activeIndex].min_promotion_performance}}
                            </div>
                            <div class="li-top-right" :style="{'margin-left':activeIndex==2 ?'-1.5rem':activeIndex==3 ?'-1rem':activeIndex==4 ?'-2.4rem':'0.2rem'}">{{activeIndex==1 ?'':memberVipList[activeIndex].max_promotion_performance}}</div>
                            <div class="li-top-right">
                               {{memberVipList[activeIndex].max_promotion_performance_two || memberVipList[activeIndex].max_promotion_performance}}
                            </div>
                        </div>
                    </div>
                     <div class="pre">
                    <img src="../../assets/newImg/lvka_footer.png" alt="" v-if="activeIndex==1">
                    <img src="../../assets/newImg/hongka_footer.png" alt="" v-if="activeIndex==2">
                    <img src="../../assets/newImg/bojin_footer.png" alt="" v-if="activeIndex==3">
                    <img src="../../assets/newImg/languan_footer.png" alt="" v-if="activeIndex==4">
                    <img src="../../assets/newImg/huangguan_footer.png" alt="" v-if="activeIndex==5">
                        </div>
                </div>
                <!-- <div class="spead-pre">
                    <div class="spe-left">推广奖金比例：4%</div>
                    <div class="spe-left">推广奖金比例：4%</div>
                </div> -->
            </div>
        </div>
        <Recommend></Recommend>
        <div class="growthValue" :class="growthValue === false ? 'on' : ''">
            <div class="pictrue">
                <img src="@assets/images/value.jpg" /><span
                    class="iconfont icon-guanbi3"
                    @click="growthTap"
                ></span>
            </div>
            <div class="conter">
                {{ illustrate }}
            </div>
        </div>
        <div class="mask" :hidden="growthValue" @click="growthTap"></div>
    </div>
</template>
<style lang="scss" scoped>
.speakvip {
    margin: 0 12px;
    background: #ffffff;
    border-radius: 4px;
    min-height: 150px;
    .speak-list {
        background: #f8f8f8;
        border-radius: 4px;
        height: 150px;
        .title {
            height: 46px;
            display: flex;
            align-items: center;
            padding-left: 11px;
            color: #333333;
            font-size: 16px;
            font-weight: 600;
        }
        .speak-li {
            .li-top {
                display: flex;
                align-items: center;
                justify-content: space-between;
                padding: 0 10px 0 10px;
                font-size: 14px;
                .li-right {
                    font-size: 13px;
                }
            }
            .cu-progress {
                background: #f9e9ea;
                height: 0.17rem;
                width: 6.5rem;
                border-radius: 0.2rem;
                margin: 11px auto;
                .bg-red {
                    background: #d01112;
                    height: 100%;
                    border-radius: 0.2rem;
                }
            }
        }
        .pre{
                 width: 100%; 
                 margin-left: -5px;  
                img{
                 width:100% ;   
                 height: 36px;
                }
            }
    }
    .spead-pre {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 0 22px;
        height: 40px;
        .spe-left {
            font-size: 13px;
            color: #333333;
        }
    }
}
.header {
    background: url("../../assets/newImg/vip_bg.png") no-repeat;
    background-size: 100% 100%;
    width: 100%;
    height: 200px;
    .slider-banner {
        margin-top: 100px;
    }
}
.speak-txt {
    text-align: center;
    background-size: 100% 100%;
    width: 219px;
    height: 31px;
    line-height: 31px;
    margin: 0 auto;
    font-size: 15px;
    color: #ffffff;
}
.speak {
    margin: 0 11px;
    min-height: 190px;
    background: #ffffff;
    border-radius: 10px;
    box-shadow: 0px 1px 15px 0px rgba(157, 157, 157, 0.2);

    .speak-people {
        margin: 20px 12px 0 12px;
        .speak-people-top {
            display: flex;
            align-items: center;
            img {
                width: 20px;
                height: 20px;
            }
            div {
                padding-left: 9px;
                font-size: 16px;
                color: #333333;
            }
        }
        .content {
            padding: 0 30px;
            color: #999999;
            font-size: 12px;
            padding-top: 12px;
        }
    }
}
.level-txt {
    width: 136px;
    height: 32px;
    line-height: 32px;
    background: linear-gradient(
        270deg,
        rgba(255, 255, 255, 0.25),
        #ffffff 42%,
        #ffffff 97%
    ) !important;
    border-radius: 10px 0px 10px 0px;
    text-align: center;
    color: #a7773b;
    font-size: 16px;
    font-weight: 600;
}
.member-center {
    .header {
        .slider-banner {
            height:auto;
            .swiper-slide {
                height: 181px;
                position: relative;
                .name {
                    font-size: 20px;
                }
                .medal {
                    width: 64px;
                    height: 79px;
                    position: absolute;
                    top: 0;
                    right: 27px;
                }
                .achievement {
                    .ach-top {
                        display: flex;
                        align-items: center;
                        justify-content: space-between;
                        padding: 22px 13px 17px 13px;
                    }
                    .cu-progress {
                        overflow: hidden;
                        height: 0.12rem;
                        background: rgba(255, 255, 255, 0.3);
                        width: 6rem;
                        border-radius: 0.2rem;
                        margin: 0 13px;
                        .bg-red {
                            background-color: #ffffff;
                            height: 100%;
                        }
                    }
                }
                .lock {
                    margin: 0;
                    padding: 12px 0 0 13px;
                }
            }
        }
    }
}
.member-center .wrapper .list .item .cu-progress .bg-red {
    background-color: #d01112;
}
</style>
<script>
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "@assets/css/swiper.min.css";
import Recommend from "@components/Recommend";
import {
    getVipInfo,
    getVipTask,
    setDetection,
    memberVip,
} from "../../api/user";
export default {
    name: "UserVip",
    components: {
        swiper,
        swiperSlide,
        Recommend,
    },
    props: {},
    data: function() {
        return {
            vipList: [], //等级列表
            vipRequire: [], //等级要求
            vipComplete: [], //完成情况
            taskCount: 0, //任务数
            grade: 0, //当前会员等级
            memberVipList: [{ name: "", proportion: 0 }], //更改后的等级
            swiperVip: {
                speed: 1000,
                effect: "coverflow",
                slidesPerView: "auto",
                centeredSlides: true,
                // loop: true,
                coverflowEffect: {
                    rotate: 0, // 旋转的角度
                    stretch: -20, // 拉伸   图片间左右的间距和密集度
                    depth: 100, // 深度   切换图片间上下的间距和密集度
                    modifier: 2, // 修正值 该值越大前面的效果越明显
                    slideShadows: false, // 页面阴影效果
                },
                observer: true,
                observeParents: true,
            },
            loading: false,
            growthValue: true,
            illustrate: "",
            activeIndex: 0,
            activeImg: require("../../assets/newImg/huangka_1.png"),
            bgImg: require("../../assets/newImg/huangka_bg.png"),
            text_bg: require("../../assets/newImg/huangka.png"),
        };
    },
    watch: {},
    computed: {
        swiper() {
            return this.$refs.mySwiper.swiper;
        },
    },
    mounted: function() {
        let that = this;
        setDetection();
        that.getInfo();
        that.member_vip();
    },
    methods: {
        active(acitve) {
            this.activeIndex = acitve;
        },
        growthTap: function() {
            this.growthValue = true;
        },
        getInfo: function() {
            let that = this;
            getVipInfo().then(
                (res) => {
                    that.vipList = res.data.list;
                    that.vipRequire = res.data.task.list;
                    that.vipComplete = res.data.task.task;
                    that.taskCount = res.data.task.reach_count;
                },
                (err) => {
                    that.$dialog.message(err.msg);
                }
            );
        },
        getTask: function() {
            let that = this;
            getVipTask(that.vipList[that.activeIndex].id).then(
                (res) => {
                    that.vipRequire = res.data.list;
                    that.vipComplete = res.data.task;
                    that.taskCount = res.data.reach_count;
                },
                (err) => {
                    that.$dialog.message(err.msg);
                }
            );
        },
        showGrow: function(item) {
            if (this.illustrate != item.illustrate)
                this.illustrate = item.illustrate;
            this.growthValue = false;
        },
        member_vip() {
            memberVip().then((res) => {
                this.memberVipList = res.data.list;
                let memberVipList=res.data.list;
                for (var i in memberVipList) {
                    memberVipList[i].activeImg =
                        i == 0
                            ? require("../../assets/newImg/huangka_1.png")
                            : i == 1
                            ? require("../../assets/newImg/lvka_1.png")
                            : i == 2
                            ? require("../../assets/newImg/hongka_1.png")
                            : i == 3
                            ? require("../../assets/newImg/huangguan_1.png")
                            : i == 4
                            ? require("../../assets/newImg/languan_1.png")
                            : i == 5
                            ? require("../../assets/newImg/bojin_1.png")
                            : "";
                    memberVipList[i].bgImg =
                        i == 0
                            ? require("../../assets/newImg/huangka_bg.png")
                            : i == 1
                            ? require("../../assets/newImg/lvka_bg.png")
                            : i == 2
                            ? require("../../assets/newImg/hongka_bg.png")
                            : i == 3
                            ? require("../../assets/newImg/huangguan_bg.png")
                            : i == 4
                            ? require("../../assets/newImg/languan_bg.png")
                            : i == 5
                            ? require("../../assets/newImg/bojin_bg.png")
                            : "";
                    memberVipList[i].text_bg =
                        i == 0
                            ? require("../../assets/newImg/huangka.png")
                            : i == 1
                            ? require("../../assets/newImg/lvka.png")
                            : i == 2
                            ? require("../../assets/newImg/hongka.png")
                            : i == 3
                            ? require("../../assets/newImg/huangguan.png")
                            : i == 4
                            ? require("../../assets/newImg/languan.png")
                            : i == 5
                            ? require("../../assets/newImg/bojin.png")
                            : "";
                }
            });
        },
        slideChange() {
            this.activeIndex = this.$refs.mySwiper.swiper.activeIndex;
            let activeIndex = this.activeIndex;
        },
    },
};
</script>
